import React from "react";

const BlurColoredBg = () => {
  return (
    <div className="blur-bg">
      <img src="/media/assets/blur-vector-1.svg" alt="" />
      <img src="/media/assets/blur-vector-2.svg" alt="" />
      <img src="/media/assets/blur-vector-3.svg" alt="" />
      <img src="/media/assets/blur-vector-4.svg" alt="" />
      <img src="/media/assets/blur-vector-5.svg" alt="" />
      <img src="/media/assets/blur-vector-6.svg" alt="" />
      <img src="/media/assets/blur-vector-7.svg" alt="" />
    </div>
  );
};

export default BlurColoredBg;
